import React from "react";
import { Table } from "antd";
import { format } from "date-fns";

const MedicalCampTable = ({ data }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Date of Submission",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      render: (createdAt) =>
        createdAt ? format(new Date(createdAt), "dd/MM/yyyy") : "-",
    },
    {
      title: "Husband/Father Name",
      dataIndex: "fatherOrHusbandName",
      key: "fatherOrHusbandName",
      align: "center",
    },
    {
      title: "DOB",
      dataIndex: "dob",
      key: "dob",
      align: "center",
      render: (dob) => (dob ? format(new Date(dob), "dd/MM/yyyy") : "-"),
    },
    { title: "Age", dataIndex: "age", key: "age", align: "center" },
    { title: "Address", dataIndex: "address", key: "address", align: "center" },
    {
      title: "Total Adults in Family",
      dataIndex: "totalAdults",
      key: "totalAdults",
      align: "center",
    },
    {
      title: "Contact No",
      dataIndex: "contactNo",
      key: "contactNo",
      align: "center",
    },
    {
      title: "Identification No",
      dataIndex: "idNo",
      key: "idNo",
      align: "center",
    },
  ];

  return (
    <Table
      rowKey="_id"
      columns={columns}
      dataSource={data}
      pagination={false}
    />
  );
};

export default MedicalCampTable;
